/**
 * Thin façade over the PostHog wrapper (OMN-360). Existing call sites use
 * `AnalyticsService.logEvent(...)`; this routes them to PostHog. It is a safe
 * no-op until analytics is configured and the user has opted in (see
 * lib/analytics/posthog).
 */
import { captureEvent } from '../lib/analytics/posthog';

export class AnalyticsService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- call sites pass
  // various typed form-data objects; matches the prior signature for compatibility.
  static async logEvent(eventName: string, eventParams?: Record<string, any>) {
    captureEvent(eventName, eventParams);
  }
}
